/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { Alert } from '@/components/global_alerts/types';
import { RiskCardType } from './types';

export const validate = (editCardType: RiskCardType, value: any, labels: Array<string>) => {
  let errors: Alert[] = [];
  if ([RiskCardType.Text, RiskCardType.Number, RiskCardType.Calculation].includes(editCardType)) {
    errors = validateTextOrNumber(value.toString(), labels[0]);
  } else {
    errors = validateAddOrRemoveItems(value, labels);
  }
  return errors;
};

const validateTextOrNumber = (value: string, label: string) => {
  const errors = [];
  if (!value.trim()) {
    errors.push(createError('error', label));
  }
  return errors;
};

const validateAddOrRemoveItems = (items: Array<any>, labels: Array<string>) => {
  const errors = [];
  if (!items.length || items.filter(item => !item.name.trim()).length) {
    errors.push(createError('error', labels[0]));
  }
  if (!items.length || items.filter(item => !item.value && item.value !== 0).length) {
    errors.push(createError('error', labels[1]));
  }
  return errors;
};

const createError = (type: string, label: string) => {
  return {
    type,
    message: `Field ${label} is required.`,
  };
};
